import { render, staticRenderFns } from "./productShop.vue?vue&type=template&id=44f9c2ec&"
import script from "./productShop.vue?vue&type=script&lang=js&"
export * from "./productShop.vue?vue&type=script&lang=js&"
import style0 from "./productShop.vue?vue&type=style&index=0&id=44f9c2ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports